import { styled, TableCell } from '@mui/material'

export const StyledCardHolderCell = styled(TableCell)(({ theme }) => ({
  width: theme.spacing(25),
  [theme.breakpoints.down('xs')]: {
    width: theme.spacing(8),
  },
}))
